import { Injectable, inject } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Product } from 'src/app/models/product.model';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ProductsService {

  private http = inject(HttpClient);

  getProducts(): Observable<Product[]> {
    return this.http.get<Product[]>( environment.apiURL + '/services/orders/get-products', { withCredentials: true })
  }

  getProductById(id: number): Observable<Product> {
    const params = new HttpParams().set("id", id.toString());
    return this.http.get<Product>( environment.apiURL + '/services/orders/get-product-by-id', { params: params, withCredentials: true })
  }

}
